export const name = 'rnWithCredentialsInterceptor';

export function installInterceptorConfig($httpProvider) {
  'ngInject';

  // Don't include this while testing because of problems with extra $http calls
  /* global __TEST__ */
  if (!__TEST__) {
    $httpProvider.interceptors.push(name);
  }
}

export default function rnWithCredentialsInterceptor($window) {
  'ngInject';

  let mainDomain;

  const interceptor = {
    request,
  };

  activate();
  return interceptor;

  /////////////////

  function activate() {
    let hostnameParts = $window.location.hostname.split('.');
    if (hostnameParts.length >= 3) {
      // If we're on a subdomain, extract the main domain
      mainDomain = hostnameParts.slice(-3).join('.');
    }
  }

  function request(config) {
    if (mainDomain) {
      // If requested url is a string (it can be a TrustedObject)
      // and contains the main domain, ensure withCredentials is set for the auth token cookie
      // to be sent with CORS requests. We used to set this with every request, but that
      // caused issues with other domains (cdn.printos.com in particular).
      if (_.isString(config.url) && _.includes(config.url, mainDomain)) {
        config.withCredentials = true;
      }
    }
    return config;
  }
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/core/http/with-credentials.interceptor.js